// Place detail data — each mention chip on the home slider links to a place here.
// URL: /places/:id
export const places = {
  // ============ Slide 01 · Adventure & Forts ============
  'harihar-fort': {
    id: 'harihar-fort',
    name: 'Harihar Fort',
    category: 'Adventure & Forts',
    location: 'Nashik, Maharashtra',
    image: 'https://images.pexels.com/photos/33304432/pexels-photo-33304432.jpeg',
    gallery: [
      'https://images.pexels.com/photos/33304432/pexels-photo-33304432.jpeg',
      'https://images.pexels.com/photos/14229957/pexels-photo-14229957.jpeg'
    ],
    tagline: 'The vertigo-inducing 90° steps of the Sahyadris',
    description: 'Harihar Fort is famed for one of the most photographed climbs in India — a set of 90-degree rock-cut steps carved directly into a triangular monolith. The final push involves 170 steps up a near-vertical face with hand-hold grooves worn smooth over centuries. From the summit you look over the Trimbak range and, on clear days, all the way to the source of the Godavari.',
    quickFacts: [
      { label: 'Altitude', value: '1,120 m' },
      { label: 'Difficulty', value: 'Challenging' },
      { label: 'Duration', value: '1 Day' },
      { label: 'Best time', value: 'Oct – Feb' }
    ],
    highlights: ['Iconic 90° rock-cut steps', '170 hand-hold carved stairs', 'Trimbak range panorama', 'Ancient water cistern at summit', 'Small Hanuman shrine at top'],
    howToReach: 'Nirgudpada village near Trimbakeshwar is the base — about 40 km from Nashik city and 4 hours by road from Mumbai/Pune.',
    tips: ['Wear grippy trekking shoes — the steps are polished smooth', 'Avoid solo climbs in monsoon (extremely slippery)', 'Carry 2L water per person', 'Start early to avoid crowd at the steps']
  },
  'kalavantin': {
    id: 'kalavantin',
    name: 'Kalavantin Durg',
    category: 'Adventure & Forts',
    location: 'Raigad, Maharashtra',
    image: 'https://images.pexels.com/photos/14229957/pexels-photo-14229957.jpeg',
    gallery: ['https://images.pexels.com/photos/14229957/pexels-photo-14229957.jpeg'],
    tagline: 'The pinnacle fort of Prabalgad',
    description: 'A slender, thumb-shaped pinnacle rising almost vertically out of the Prabalmachi plateau, Kalavantin Durg is one of the Sahyadris\u2019 boldest silhouettes. The last stretch involves a set of narrow open steps cut into the cliff \u2014 no railings, no rope, just an unforgettable view once you reach the tiny summit crown.',
    quickFacts: [
      { label: 'Altitude', value: '681 m' },
      { label: 'Difficulty', value: 'Challenging' },
      { label: 'Duration', value: '1 Day' },
      { label: 'Best time', value: 'Nov – Feb' }
    ],
    highlights: ['Open cliff-cut summit stairs', 'Overnight camp at Prabalmachi', 'Twin Prabalgad view', 'Sunrise photography spot', 'Grade V exposure for climbers'],
    howToReach: 'Base village Thakurwadi, near Panvel \u2014 a 90-minute drive from Mumbai and 3 hours from Pune.',
    tips: ['Not recommended in wet weather', 'Camp overnight at Prabalmachi for sunrise start', 'Carry a headlamp for pre-dawn climb', 'Rope-assisted ascent is available in season']
  },
  'mangi-tungi': {
    id: 'mangi-tungi',
    name: 'Mangi Tungi',
    category: 'Adventure & Forts',
    location: 'Nashik, Maharashtra',
    image: 'https://images.unsplash.com/photo-1707840422122-268356e197c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1707840422122-268356e197c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Twin pinnacles of Jain pilgrimage & rock trek',
    description: 'Mangi Tungi is a pair of stony pinnacles rising over the Satmala hills near Nashik. Sacred to Digambara Jains \u2014 the site hosts a 108-foot Rishabhdev idol and dozens of rock-cut cave shrines. The trek passes both peaks (Mangi and Tungi) with a moderate climb rewarded by wide plateau views.',
    quickFacts: [
      { label: 'Altitude', value: '1,331 m' },
      { label: 'Difficulty', value: 'Moderate' },
      { label: 'Duration', value: '1 Day' },
      { label: 'Best time', value: 'Oct – Feb' }
    ],
    highlights: ['108 ft Rishabhdev statue', 'Ancient Jain rock caves', 'Twin-pinnacle traverse', 'Panoramic Satmala plateau view', 'Nightlong bhajans during festivals'],
    howToReach: 'Base village Bhilwad in Baglan taluka, Nashik district. ~120 km from Nashik city.',
    tips: ['Respect the pilgrimage site — modest attire', 'Shoes must be left before the caves', 'Water & snacks best carried from base', 'Combine with Saptashrungi on the same trip']
  },
  'kumara-parvata': {
    id: 'kumara-parvata',
    name: 'Kumara Parvata',
    category: 'Adventure & Forts',
    location: 'Kukke Subramanya, Karnataka',
    image: 'https://images.unsplash.com/photo-1622725859789-8e9ccf920693?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1622725859789-8e9ccf920693?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Karnataka\u2019s toughest one-shot summit trek',
    description: 'A brutally beautiful 13 km climb through shola forest and rolling grasslands, Kumara Parvata gains almost 1,500 m in a single ascent. Trekkers overnight at Bhattara Mane \u2014 the last teahouse before the summit \u2014 to catch a magical sunrise above the clouds.',
    quickFacts: [
      { label: 'Altitude', value: '1,712 m' },
      { label: 'Difficulty', value: 'Challenging' },
      { label: 'Duration', value: '2 Days' },
      { label: 'Best time', value: 'Nov – Feb' }
    ],
    highlights: ['Bhattara Mane teahouse stay', 'Shola-grassland transition', 'Sunrise above cloud sea', 'Kukke Subramanya temple base', 'Grade IV strenuous trek'],
    howToReach: 'Base is Kukke Subramanya, well connected by train and road \u2014 5 hours from Bengaluru, 3 hours from Mangaluru.',
    tips: ['Book Bhattara Mane in advance (limited spots)', 'Carry 3L water & electrolytes', 'Trek permit issued at forest gate', 'Avoid monsoon — leeches everywhere']
  },
  'kodachadri': {
    id: 'kodachadri',
    name: 'Kodachadri',
    category: 'Adventure & Forts',
    location: 'Shivamogga, Karnataka',
    image: 'https://images.pexels.com/photos/11170475/pexels-photo-11170475.jpeg',
    gallery: ['https://images.pexels.com/photos/11170475/pexels-photo-11170475.jpeg'],
    tagline: 'Mist-covered peak of the Western Ghats',
    description: 'A mystical peak in the heart of the Mookambika reserve, Kodachadri is legendary for its wind-swept summit temple, the Sarvajna Peeta \u2014 said to be where Adi Shankaracharya meditated. Reach the top by jeep and a short trek, or hike the full 12 km trail through evergreen shola.',
    quickFacts: [
      { label: 'Altitude', value: '1,343 m' },
      { label: 'Difficulty', value: 'Moderate' },
      { label: 'Duration', value: '1-2 Days' },
      { label: 'Best time', value: 'Oct – Mar' }
    ],
    highlights: ['Sarvajna Peeta summit shrine', 'Hidachi Falls trail', 'Kollur Mookambika temple visit', 'Sunrise over Arabian Sea', 'Wildlife-sanctuary birding'],
    howToReach: 'Base village Kattinahole/Nagodi, 25 km from Kollur. Daily jeep service from Nittur/Kattinahole to the summit.',
    tips: ['Book a jeep in advance during holidays', 'Carry warm layers — the summit is windy', 'Combine with Mookambika darshan', 'Homestays at Nittur are excellent value']
  },

  // ============ Slide 02 · Sea & Water Adventures ============
  'kasheli-falls': {
    id: 'kasheli-falls',
    name: 'Kasheli Falls',
    category: 'Sea & Water Adventures',
    location: 'Sindhudurg, Maharashtra',
    image: 'https://images.pexels.com/photos/9817689/pexels-photo-9817689.jpeg',
    gallery: ['https://images.pexels.com/photos/9817689/pexels-photo-9817689.jpeg'],
    tagline: 'Twin-tier Konkan cascade',
    description: 'A short forest walk brings you to Kasheli\u2019s twin waterfall drops \u2014 the upper tier cascades down mossy black rock into a natural bathing pool, while the lower step plunges into a wider ravine. Best visited in the tail end of monsoon when the flow is strong but the trails are firm.',
    quickFacts: [
      { label: 'Altitude', value: 'Sea level' },
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: 'Half Day' },
      { label: 'Best time', value: 'Aug – Nov' }
    ],
    highlights: ['Twin-tier cascade', 'Natural swimming pool', 'Konkani village lunch', 'Malvani thali dinners nearby', 'Combine with Sindhudurg fort'],
    howToReach: 'Kasheli village, off the Mumbai-Goa highway (NH66), ~30 km from Kankavli.',
    tips: ['Wet-shoes recommended', 'Stay near Malvan for the best coastal food', 'Avoid peak monsoon (July) \u2014 slippery rocks', 'Combine with a Tarkarli snorkelling day']
  },
  'ratnagiri': {
    id: 'ratnagiri',
    name: 'Ratnagiri',
    category: 'Sea & Water Adventures',
    location: 'Konkan Coast, Maharashtra',
    image: 'https://images.unsplash.com/photo-1494783367193-149034c05e8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1494783367193-149034c05e8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Alphonso mangoes & clean coastal beaches',
    description: 'Ratnagiri is the cultural capital of Konkan \u2014 famed for Alphonso mangoes, black-sand Ganpatipule beach, Thibaw palace, and Lokmanya Tilak\u2019s ancestral home. A slow coastal town made for scooter rides between orchards, forts and fishing harbours.',
    quickFacts: [
      { label: 'Altitude', value: 'Sea level' },
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: '2 Days' },
      { label: 'Best time', value: 'Nov – May' }
    ],
    highlights: ['Ganpatipule beach temple', 'Thibaw palace museum', 'Alphonso mango orchards (Mar-May)', 'Ratnadurg fort sunset', 'Konkan fisherman market'],
    howToReach: 'Konkan Railway (Ratnagiri station) or NH66 by road \u2014 7 hours from Mumbai, 5 from Pune.',
    tips: ['Best visited Mar-May for mango season', 'Stay near Ganpatipule for beach', 'Rent a scooter to explore', 'Try modak & solkadi']
  },
  'karkala': {
    id: 'karkala',
    name: 'Karkala',
    category: 'Sea & Water Adventures',
    location: 'Udupi, Karnataka',
    image: 'https://images.unsplash.com/photo-1622725859789-8e9ccf920693?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1622725859789-8e9ccf920693?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Ancient Jain temple town at the edge of the Ghats',
    description: 'Karkala sits where the coastal plain meets the Western Ghats \u2014 known for its 42-foot Bahubali monolith carved in 1432, several stone-carved Jain basadis, and rocky hilltop temples. A quiet, slow-travel stopover between Udupi and the Kudremukha ranges.',
    quickFacts: [
      { label: 'Altitude', value: '85 m' },
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: '1 Day' },
      { label: 'Best time', value: 'Oct – Feb' }
    ],
    highlights: ['Bahubali monolith (42 ft)', 'Chaturmukha Basadi', 'Anantashayana temple', 'Padutirupathi Venkataramana', 'Kudremukha day-trip base'],
    howToReach: '55 km from Mangaluru, 40 km from Udupi \u2014 well connected by road and bus.',
    tips: ['Basadi opens early morning', 'Combine with Mahamastakabhisheka festival (12-yearly)', 'Local Udupi food is legendary', 'Stay in Mangaluru or Udupi']
  },
  'gokarna': {
    id: 'gokarna',
    name: 'Gokarna',
    category: 'Sea & Water Adventures',
    location: 'Uttara Kannada, Karnataka',
    image: 'https://images.unsplash.com/photo-1583212292454-1fe6229603b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1583212292454-1fe6229603b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Four beaches, one holy town',
    description: 'A temple town famed for the ancient Mahabaleshwar Shiva shrine and its string of four beaches \u2014 Kudle, Om, Half-Moon and Paradise \u2014 all connected by a scenic clifftop trail. Popular with backpackers for its slow, unhurried, holy-meets-beach vibe.',
    quickFacts: [
      { label: 'Altitude', value: 'Sea level' },
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: '2-3 Days' },
      { label: 'Best time', value: 'Oct – Feb' }
    ],
    highlights: ['Mahabaleshwar Shiva temple', '4-beach clifftop trek', 'Om beach sunset', 'Kudle beach yoga shalas', 'Sacred Koti Tirtha tank'],
    howToReach: 'Konkan Railway to Gokarna Road station, or 4 hours by road from Mangaluru/Hubli.',
    tips: ['Respect temple dress code in Old town', 'Try coastal Konkani thali', 'Trek the beach loop early morning', 'Avoid peak monsoon']
  },
  'honnavara': {
    id: 'honnavara',
    name: 'Honnavara',
    category: 'Sea & Water Adventures',
    location: 'Uttara Kannada, Karnataka',
    image: 'https://images.unsplash.com/photo-1486673748761-a8d18475c757?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1486673748761-a8d18475c757?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Sharavathi meets the Arabian Sea',
    description: 'The coastal town where the mighty Sharavathi river empties into the Arabian Sea. Honnavara offers backwater boat rides, mangrove kayaking through Aghanashini estuary, and long, wild beaches like Apsarakonda and Kasarkod that are still gloriously uncrowded.',
    quickFacts: [
      { label: 'Altitude', value: 'Sea level' },
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: '2 Days' },
      { label: 'Best time', value: 'Oct – Mar' }
    ],
    highlights: ['Sharavathi estuary boat ride', 'Apsarakonda beach & falls', 'Kasarkod turtle nesting beach', 'Mangrove kayaking', 'Sunset from Idagunji bridge'],
    howToReach: 'Konkan Railway Honnavar station, 60 km south of Gokarna.',
    tips: ['Combine with Jog Falls (60 km)', 'Book boat rides in advance', 'Turtle nesting is Nov-Feb', 'Homestays at Kumta are excellent']
  },

  // ============ Slide 03 · Devotion & Spirituality ============
  '12-jyotirlingas': {
    id: '12-jyotirlingas',
    name: '12 Jyotirlingas',
    category: 'Devotion & Spirituality',
    location: 'Pan-India',
    image: 'https://images.unsplash.com/photo-1627938823193-fd13c1c867dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1627938823193-fd13c1c867dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'The twelve luminous Shiva shrines',
    description: 'A pilgrimage circuit visiting the twelve self-manifested Jyotirlinga temples of Lord Shiva \u2014 Somnath, Mallikarjuna, Mahakaleshwar, Omkareshwar, Kedarnath, Bhimashankar, Kashi Vishwanath, Trimbakeshwar, Vaidyanath, Nageshwar, Rameshwaram and Grishneshwar. A once-in-a-lifetime journey across the country.',
    quickFacts: [
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: '18-25 Days' },
      { label: 'Best time', value: 'Oct – Mar' },
      { label: 'Shrines', value: '12 total' }
    ],
    highlights: ['Somnath (Gujarat)', 'Kashi Vishwanath (Varanasi)', 'Kedarnath (Uttarakhand)', 'Rameshwaram (Tamil Nadu)', 'Mahakaleshwar (Ujjain)', 'Trimbakeshwar (Nashik)'],
    howToReach: 'The circuit typically starts at Somnath and ends at Grishneshwar \u2014 combines flights, trains and road travel across 9 states.',
    tips: ['Priest coordination greatly speeds up darshan', 'Kedarnath requires a mountain trek (Apr-Nov only)', 'Modest attire mandatory', 'Book Rameshwaram-Madurai train early']
  },
  'char-dham': {
    id: 'char-dham',
    name: 'Char Dham',
    category: 'Devotion & Spirituality',
    location: 'Uttarakhand',
    image: 'https://images.unsplash.com/photo-1454496522488-7a8e488e8606?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1454496522488-7a8e488e8606?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'The four sacred abodes of the Himalayas',
    description: 'Yamunotri, Gangotri, Kedarnath and Badrinath \u2014 the four sacred shrines that form the Chota Char Dham circuit of the Himalayas. Together they honour the source of the Yamuna and Ganga, and the Himalayan seats of Shiva and Vishnu. A journey of high altitude, weather challenges and deep spiritual reward.',
    quickFacts: [
      { label: 'Altitude', value: 'Up to 3,583 m' },
      { label: 'Difficulty', value: 'Moderate' },
      { label: 'Duration', value: '10-12 Days' },
      { label: 'Best time', value: 'May – Jun, Sep – Oct' }
    ],
    highlights: ['Yamunotri thermal springs', 'Gangotri glacier source', 'Kedarnath 14 km trek', 'Badrinath by the Alaknanda', 'Panch Prayag confluences'],
    howToReach: 'Base at Haridwar or Dehradun. Helicopter yatra available for elderly pilgrims.',
    tips: ['Yatra permit required (biometric registration)', 'Portal opens April/May, closes Oct/Nov', 'Acclimatise for 2 days before Kedarnath', 'Carry warm layers even in summer']
  },
  'shikharji': {
    id: 'shikharji',
    name: 'Shikharji',
    category: 'Devotion & Spirituality',
    location: 'Parasnath Hills, Jharkhand',
    image: 'https://images.unsplash.com/photo-1617380613434-7495e9b45dfb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1617380613434-7495e9b45dfb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Holiest hill for Jain pilgrims',
    description: 'Also called Sammed Shikharji, this is the mountain where twenty of the twenty-four Jain Tirthankaras attained moksha. Pilgrims walk barefoot along the 27 km parikrama trail up and around Parasnath hill \u2014 the highest peak in Jharkhand \u2014 pausing at each Tonk shrine.',
    quickFacts: [
      { label: 'Altitude', value: '1,365 m' },
      { label: 'Difficulty', value: 'Moderate' },
      { label: 'Duration', value: '2 Days' },
      { label: 'Best time', value: 'Oct – Mar' }
    ],
    highlights: ['27 km barefoot parikrama', '20 Tonk shrines on peak', 'Highest hill in Jharkhand', 'Digambar & Shwetambar temples', 'Sunrise from Jal Mandir'],
    howToReach: 'Nearest railhead Parasnath, 24 km from Madhuban base. 6 hours from Kolkata, 4 from Ranchi.',
    tips: ['Pilgrimage is done barefoot by tradition', 'Doli service available for elderly', 'Start walk before dawn to avoid sun', 'Avoid trekking in monsoon']
  },

  // ============ Slide 04 · Himalayas ============
  'srinagar': {
    id: 'srinagar',
    name: 'Srinagar',
    category: 'Himalayas',
    location: 'Kashmir Valley',
    image: 'https://images.unsplash.com/photo-1617380613434-7495e9b45dfb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1617380613434-7495e9b45dfb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Shikaras, saffron gardens and Mughal charm',
    description: 'The summer capital of Kashmir sits along the Dal and Nigeen lakes, a city of houseboats, wood-carved shrines and Mughal-era gardens. Visit Shalimar Bagh, wander the old town\u2019s pashmina lanes, and drift across Dal at dawn for an unforgettable shikara ride.',
    quickFacts: [
      { label: 'Altitude', value: '1,585 m' },
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: '3-4 Days' },
      { label: 'Best time', value: 'Apr – Oct' }
    ],
    highlights: ['Dal Lake shikara ride', 'Mughal gardens (Shalimar, Nishat)', 'Hazratbal shrine', 'Old-town wood-carved mosques', 'Sonmarg & Gulmarg day-trips'],
    howToReach: 'Direct flights from Delhi/Mumbai to Srinagar (SXR). Road via Jammu \u2014 NH44.',
    tips: ['Book houseboats in advance in summer', 'Try wazwan feast (Kashmiri thali)', 'Combine with Gulmarg gondola', 'Autumn (Oct) chinar leaves are unmissable']
  },
  'jammu-and-kashmir': {
    id: 'jammu-and-kashmir',
    name: 'Jammu & Kashmir',
    category: 'Himalayas',
    location: 'Northern India',
    image: 'https://images.unsplash.com/photo-1454496522488-7a8e488e8606?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1454496522488-7a8e488e8606?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'From temple hills to snow valleys',
    description: 'A land of contrasts \u2014 the sacred pilgrim town of Katra with the Vaishno Devi cave shrine, the snowscapes of Patnitop and Bhaderwah, the meadow paradise of Gulmarg, and the highland deserts around Sonmarg. The complete Himalayan Indian experience in one union territory.',
    quickFacts: [
      { label: 'Altitude', value: 'Up to 3,979 m' },
      { label: 'Difficulty', value: 'Easy-Moderate' },
      { label: 'Duration', value: '7-10 Days' },
      { label: 'Best time', value: 'Apr – Oct' }
    ],
    highlights: ['Vaishno Devi cave shrine', 'Patnitop meadows', 'Gulmarg gondola', 'Sonmarg pony trails', 'Amarnath yatra (in season)'],
    howToReach: 'Flights to Jammu (IXJ) or Srinagar (SXR). Rail terminus at Katra for Vaishno Devi.',
    tips: ['Vaishno Devi darshan requires yatra parchi (permit)', 'Amarnath yatra runs Jul-Aug only', 'Winter (Jan-Feb) is skiing season at Gulmarg', 'Carry warm layers year-round']
  },
  'manali': {
    id: 'manali',
    name: 'Manali',
    category: 'Himalayas',
    location: 'Kullu Valley, Himachal',
    image: 'https://images.unsplash.com/photo-1606667544139-81e47935d769?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1606667544139-81e47935d769?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Pine forests, snow peaks & old-town cafés',
    description: 'Manali sits at the head of the Kullu valley on the Beas river \u2014 a mountain town of hot springs, pine forests and old wood-shingle temples. Base for trips to Rohtang, Solang, Bhrigu Lake and further into Spiti. Old Manali\u2019s cafés and Hadimba temple are winter classics.',
    quickFacts: [
      { label: 'Altitude', value: '2,050 m' },
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: '3-5 Days' },
      { label: 'Best time', value: 'Mar – Jun, Oct – Feb' }
    ],
    highlights: ['Old Manali cafés', 'Hadimba temple', 'Vashisht hot springs', 'Solang Valley paragliding', 'Rohtang Pass day-trip', 'Bhrigu Lake trek'],
    howToReach: 'Overnight bus from Delhi/Chandigarh, or flights to Bhuntar (KUU) 50 km away.',
    tips: ['Rohtang permit required online', 'Winter chains needed on rentals', 'Try trout at riverside dhabas', 'Homestays in Vashisht for old-world feel']
  },
  'spiti': {
    id: 'spiti',
    name: 'Spiti',
    category: 'Himalayas',
    location: 'Trans-Himalaya, Himachal',
    image: 'https://images.unsplash.com/photo-1607836046730-3317bd58a31b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1607836046730-3317bd58a31b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'The cold desert of monasteries',
    description: 'Spiti is a moonlike Tibetan-Buddhist valley behind the great Himalayan range \u2014 a cold desert of ochre mountains, whitewashed monasteries and centuries-old villages perched above 4,000 m. Home to Key Monastery, Langza\u2019s fossil fields, Kibber\u2014 the world\u2019s highest motorable village \u2014 and the world\u2019s highest post office at Hikkim.',
    quickFacts: [
      { label: 'Altitude', value: 'Up to 4,590 m' },
      { label: 'Difficulty', value: 'Moderate' },
      { label: 'Duration', value: '7-9 Days' },
      { label: 'Best time', value: 'May – Oct' }
    ],
    highlights: ['Key Monastery', 'Langza fossil village', 'Kibber \u2014 highest motorable village', 'Hikkim world\u2019s highest post office', 'Tabo 1,000-year monastery', 'Dhankar cliff fort'],
    howToReach: 'Two routes: Shimla-Kinnaur (open all year) or Manali-Kunzum (Jun-Oct only).',
    tips: ['Acclimatise in Kalpa or Nako before Kaza', 'Inner-line permits required for foreigners', 'Carry cash \u2014 ATMs are unreliable', 'Homestays over hotels for authentic feel']
  },
  'chandratal': {
    id: 'chandratal',
    name: 'Chandratal',
    category: 'Himalayas',
    location: 'Spiti, Himachal',
    image: 'https://images.unsplash.com/photo-1660622016391-ff0c0b7992da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1660622016391-ff0c0b7992da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'The crescent moon lake',
    description: 'A high-altitude glacial lake shaped like a crescent moon, Chandratal sits at 4,300 m in a broad meadow ringed by scree slopes. The colour of the water shifts from turquoise to deep blue across the day, and the night sky is a rare, unpolluted Milky Way canvas.',
    quickFacts: [
      { label: 'Altitude', value: '4,300 m' },
      { label: 'Difficulty', value: 'Moderate' },
      { label: 'Duration', value: '1-2 Days' },
      { label: 'Best time', value: 'Jun – Sep' }
    ],
    highlights: ['Crescent-shaped glacial lake', 'Camping under Milky Way', 'Colour-changing waters', 'Wildflower meadow trek', 'Access via Kunzum Pass'],
    howToReach: 'Road from Manali via Atal Tunnel + Batal (2 days). Kunzum Pass approach is scenic.',
    tips: ['Camp 3 km before the lake (bio-reserve rule)', 'AMS is a real risk \u2014 acclimatise', 'No permanent structures allowed', 'Carry all your waste back']
  },

  // ============ Slide 05 · Waterfalls & Nature ============
  'jog-falls': {
    id: 'jog-falls',
    name: 'Jog Falls',
    category: 'Waterfalls & Nature',
    location: 'Shivamogga, Karnataka',
    image: 'https://images.unsplash.com/photo-1660294534711-75a9474fecb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1660294534711-75a9474fecb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'India\u2019s tallest plunge waterfall',
    description: 'Where the Sharavathi river drops a spectacular 253 m over a wide granite cliff in four distinct streams \u2014 Raja, Rani, Roarer and Rocket. Jog is thunderous during monsoon and refined post-October when the mist parts to reveal all four columns.',
    quickFacts: [
      { label: 'Altitude', value: '488 m' },
      { label: 'Height', value: '253 m plunge' },
      { label: 'Duration', value: '1 Day' },
      { label: 'Best time', value: 'Aug – Dec' }
    ],
    highlights: ['253 m unbroken plunge', 'Four named cascades', 'Viewpoint terraces', 'Sharavathi backwaters', 'Sunset from British bungalow'],
    howToReach: '30 km from Sagara. 6 hours from Bengaluru, 3 from Shivamogga.',
    tips: ['Post-monsoon flow is most photogenic', 'Base at Sagara for good homestays', 'Combine with Dabbe Falls', 'Avoid the descent trail in peak monsoon']
  },
  'dabbe': {
    id: 'dabbe',
    name: 'Dabbe Falls',
    category: 'Waterfalls & Nature',
    location: 'Shivamogga, Karnataka',
    image: 'https://images.unsplash.com/photo-1521206644285-8db1549e484f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1521206644285-8db1549e484f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'The hidden Sharavathi cascade',
    description: 'Dabbe is a lesser-known 200 m tiered waterfall inside the Sharavathi Wildlife Sanctuary. Reaching it involves a jeep ride through areca-nut estates followed by a moderate 45-minute forest trek. Fewer crowds, deeper jungle and a magical bathing pool at the base.',
    quickFacts: [
      { label: 'Height', value: '~200 m tiered' },
      { label: 'Difficulty', value: 'Moderate' },
      { label: 'Duration', value: 'Half Day' },
      { label: 'Best time', value: 'Sep – Dec' }
    ],
    highlights: ['200 m tiered cascade', 'Jeep + forest trek combo', 'Bathing pool at base', 'Sharavathi wildlife sanctuary', 'Elephant sightings (rare)'],
    howToReach: 'Base village Hosagadde, 20 km from Sagara. 4WD jeep ride to trailhead is mandatory.',
    tips: ['Book the jeep in advance', 'Wear grippy shoes for last section', 'Carry snacks & water', 'Sunday crowds are heavier']
  },
  'nanemachi': {
    id: 'nanemachi',
    name: 'Nanemachi',
    category: 'Waterfalls & Nature',
    location: 'Raigad, Maharashtra',
    image: 'https://images.unsplash.com/photo-1626715185400-49cccfabc10f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1626715185400-49cccfabc10f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'The untouched Konkan rainforest waterfall',
    description: 'A well-kept secret of the Konkan region, Nanemachi is a monsoon-only cascade tucked deep inside dense rainforest. The trek involves crossing several streams and climbing rocky steps before you finally arrive at a wide amphitheatre of falling water and dark pools.',
    quickFacts: [
      { label: 'Difficulty', value: 'Moderate' },
      { label: 'Duration', value: '1 Day' },
      { label: 'Best time', value: 'Jul – Sep' },
      { label: 'Trek', value: '5 km one way' }
    ],
    highlights: ['Monsoon-only cascade', 'Rainforest stream crossings', 'Dark natural pools', 'Wild-mushroom sightings', 'Local Konkani lunch'],
    howToReach: 'Base village near Poladpur, off NH66. 4 hours drive from Pune, 5 from Mumbai.',
    tips: ['Only visit in active monsoon', 'Hire a local guide \u2014 unmarked trail', 'Leeches are common \u2014 use salt/repellent', 'Waterproof your electronics']
  },
  'marleshwar': {
    id: 'marleshwar',
    name: 'Marleshwar',
    category: 'Waterfalls & Nature',
    location: 'Ratnagiri, Maharashtra',
    image: 'https://images.unsplash.com/photo-1610044847457-f6aabcbb67d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1610044847457-f6aabcbb67d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Cave-temple waterfall of the Konkan',
    description: 'A Shiva temple hidden inside a natural cave, with the Bav waterfall crashing right beside it \u2014 Marleshwar is one of the Konkan\u2019s most cinematic pilgrimage spots. A short climb of stairs leads through a suspension bridge before you reach the cave shrine.',
    quickFacts: [
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: 'Half Day' },
      { label: 'Best time', value: 'Aug – Dec' },
      { label: 'Steps', value: '~500' }
    ],
    highlights: ['Cave Shiva temple', 'Bav waterfall adjacent', 'Suspension bridge walk', 'Konkan homestay lunch', 'Combine with Ganpatipule'],
    howToReach: 'Near Marleshwar village, Sangameshwar taluka \u2014 65 km from Ratnagiri.',
    tips: ['Cave shrine floor stays wet \u2014 no leather', 'Avoid crowded Mondays', 'Best in September post-rain', 'Try Konkani modak nearby']
  },
  'kalu': {
    id: 'kalu',
    name: 'Kalu Waterfalls',
    category: 'Waterfalls & Nature',
    location: 'Malshej Ghat, Maharashtra',
    image: 'https://images.pexels.com/photos/9817689/pexels-photo-9817689.jpeg',
    gallery: ['https://images.pexels.com/photos/9817689/pexels-photo-9817689.jpeg'],
    tagline: '1,200 ft cascade hidden below Malshej',
    description: 'One of Maharashtra\u2019s largest waterfalls \u2014 a 1,200 ft multi-tier cascade in a dense forested amphitheatre below Malshej Ghat. Reaching Kalu Falls requires a 2-hour trek through knee-deep streams during monsoon, but the sight of the full plunge is astonishing.',
    quickFacts: [
      { label: 'Height', value: '~365 m' },
      { label: 'Difficulty', value: 'Moderate' },
      { label: 'Duration', value: '1 Day' },
      { label: 'Best time', value: 'Sep – Nov' }
    ],
    highlights: ['1,200 ft cascade', 'Dense forest amphitheatre', 'Post-monsoon trek magic', 'Malshej plateau views', 'Combine with Reverse Falls'],
    howToReach: 'Base at Thitabi village near Malshej Ghat. 90 minutes from Junnar/Ahmednagar.',
    tips: ['Not accessible in peak monsoon (July)', 'Hire a base-village guide', 'Waterproof gear essential', 'Start trek by 7 AM']
  },
  'kumbhe': {
    id: 'kumbhe',
    name: 'Kumbhe',
    category: 'Waterfalls & Nature',
    location: 'Raigad, Maharashtra',
    image: 'https://images.unsplash.com/photo-1521206644285-8db1549e484f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1521206644285-8db1549e484f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'Roaring monsoon plunge of the Konkan',
    description: 'A wide, powerful waterfall tucked in the Kumbhe village of Raigad, this cascade drops in a single sheet into a deep gorge. The nearby hamlets serve simple Konkani fare, and the surrounding jungle turns emerald green during monsoon.',
    quickFacts: [
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: 'Half Day' },
      { label: 'Best time', value: 'Jul – Sep' },
      { label: 'Trek', value: '1 km one way' }
    ],
    highlights: ['Wide sheet cascade', 'Deep plunge gorge', 'Local Konkani thali', 'Combine with Devkund trek', 'Riverside picnic spots'],
    howToReach: 'Kumbhe village, 20 km from Mangaon on the Mumbai-Goa highway.',
    tips: ['Peak in Aug \u2014 loud & full flow', 'Do not swim in the gorge', 'Pair with Devkund on the same trip', 'Camp overnight for sunrise view']
  },
  'meghalaya': {
    id: 'meghalaya',
    name: 'Meghalaya',
    category: 'Waterfalls & Nature',
    location: 'North-East India',
    image: 'https://images.unsplash.com/photo-1614164948797-f5e92b825a62?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1614164948797-f5e92b825a62?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'The abode of clouds',
    description: 'The wettest region in India, Meghalaya is a land of living-root bridges, sky-clear rivers, deep caves and Khasi/Jaintia hospitality. Cherrapunji, Mawsynram and Nongriat form the classic loop, while Dawki\u2019s crystal-clear Umngot river feels almost unreal.',
    quickFacts: [
      { label: 'Altitude', value: '1,500 m avg' },
      { label: 'Difficulty', value: 'Easy-Moderate' },
      { label: 'Duration', value: '7 Days' },
      { label: 'Best time', value: 'Oct – May' }
    ],
    highlights: ['Nongriat double-decker root bridge', 'Dawki Umngot boating', 'Mawlynnong \u2014 Asia\u2019s cleanest village', 'Krang Suri Falls', 'Cherrapunji viewpoints'],
    howToReach: 'Fly into Guwahati, then 3-hour road to Shillong. Local taxis/tours from there.',
    tips: ['Best weather is Oct-Nov & Feb-Apr', 'Homestay with Khasi families for authentic feel', 'Nongriat trek is 3,500 steps', 'Book Dawki boats in advance']
  },
  'kerala': {
    id: 'kerala',
    name: 'Kerala',
    category: 'Waterfalls & Nature',
    location: 'South India',
    image: 'https://images.unsplash.com/photo-1652645510868-5887f7e8b87b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    gallery: ['https://images.unsplash.com/photo-1652645510868-5887f7e8b87b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600'],
    tagline: 'God\u2019s own country',
    description: 'A slow, green state of backwaters, spice hills and beach villages. Alleppey\u2019s kettuvallam houseboats, Munnar\u2019s rolling tea gardens, Wayanad\u2019s rainforest treks and Fort Kochi\u2019s cobbled Portuguese quarters make Kerala one of India\u2019s most complete road trips.',
    quickFacts: [
      { label: 'Altitude', value: 'Sea level to 2,700 m' },
      { label: 'Difficulty', value: 'Easy' },
      { label: 'Duration', value: '7-10 Days' },
      { label: 'Best time', value: 'Sep – Mar' }
    ],
    highlights: ['Alleppey backwater houseboat', 'Munnar tea plantations', 'Periyar wildlife cruise', 'Kathakali & Kalari show', 'Fort Kochi walking tour', 'Athirapally waterfalls'],
    howToReach: 'Fly into Kochi (COK), Trivandrum (TRV) or Calicut (CCJ) \u2014 all well connected.',
    tips: ['Ayurveda spas are best done at length', 'Backwater houseboats are a must', 'Try local seafood at Marari', 'October onwards is festival season']
  }
};

// Convert a mention label into a slug id that matches keys above
export function mentionToSlug(label) {
  return label
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}
